/**
 * API配置文件
 * 统一管理API相关的配置信息
 */

// 获取当前环境
const getEnvironment = () => {
  // 优先使用webpack注入的环境变量
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV) {
    return process.env.NODE_ENV;
  }

  // 如果webpack环境变量不可用，根据域名判断环境
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.')) {
      return 'development';
    }
  }

  // 默认为生产环境
  return 'production';
};

// 获取基础API URL
const getBaseApiUrl = () => {
  // 优先使用webpack注入的BASE_API_URL环境变量
  if (typeof process !== 'undefined' && process.env && process.env.BASE_API_URL) {
    return process.env.BASE_API_URL;
  }

  // 根据环境返回默认值
  const env = getEnvironment();
  return env === 'production'
    ? 'http://tts.pg-code-go.com/api'
    : 'http://localhost:8080/api';
};

// API基础配置
export const API_CONFIG = {
  // 基础URL - 统一通过环境变量配置
  BASE_URL: getBaseApiUrl(),

  // 当前环境
  ENVIRONMENT: getEnvironment(),

  // 请求超时时间
  TIMEOUT: 72000000,

  // 重试次数
  RETRY_COUNT: 3,

  // 重试延迟时间（毫秒）
  RETRY_DELAY: 1000
}

// 调试信息（仅在开发环境下输出）
if (API_CONFIG.ENVIRONMENT === 'development' && typeof console !== 'undefined') {
  console.log('[API CONFIG] 当前环境:', API_CONFIG.ENVIRONMENT);
  console.log('[API CONFIG] 基础URL:', API_CONFIG.BASE_URL);
  console.log('[API CONFIG] process.env.NODE_ENV:', typeof process !== 'undefined' ? process.env.NODE_ENV : 'undefined');
  console.log('[API CONFIG] process.env.BASE_API_URL:', typeof process !== 'undefined' ? process.env.BASE_API_URL : 'undefined');
}

// API端点配置
export const API_ENDPOINTS = {
  // 认证相关
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    USER_INFO: '/user/info'
  },

  // 语音合成相关
  VOICE: {
    MODELS: '/voice/models',
    SYNTHESIS: '/voice/synthesis',
    RECORDS: '/user/synthesis-records',
    DELETE_RECORD: '/user/synthesis-records',
    BATCH_DELETE: '/user/synthesis-records/batch'
  },

  // 用户相关
  USER: {
    PROFILE: '/user/profile',
    PASSWORD: '/user/password',
    STATS: '/user/stats',
    POINTS: '/user/points',
    POINT_RECORDS: '/user/point-records',
    RECHARGE: '/user/points/recharge',
    AVATAR: '/user/avatar',
    CONFIG: '/user/config'
  },

  // 验证码相关
  CAPTCHA: {
    GENERATE: '/captcha/generate',
    VERIFY: '/captcha/verify'
  }
}

// HTTP状态码
export const HTTP_STATUS = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500
}

// 错误消息
export const ERROR_MESSAGES = {
  NETWORK_ERROR: '网络连接失败，请检查网络设置',
  TIMEOUT_ERROR: '请求超时，请稍后重试',
  SERVER_ERROR: '服务器错误，请稍后重试',
  UNAUTHORIZED: '登录已过期，请重新登录',
  FORBIDDEN: '没有权限访问该资源',
  NOT_FOUND: '请求的资源不存在'
}



// WEBPACK FOOTER //
// ./src/api/config.js